import { Directive, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appNoSpecialChars]'
})
export class NoSpecialCharsDirective {
  @Input() allowAt: boolean = false;
  @Input() name: string = '';

  constructor(private ngControl: NgControl) { }

  @HostListener('input', ['$event'])

  onInputChange(event: any) {
    const value = this.ngControl.control?.value || '';
    let sanitized = '';
  
    if (this.name === 'address') {
      const regex = /[^a-zA-Z0-9áéíóúÁÉÍÓÚñÑ\s#\-.,]/g;
      sanitized = value.normalize("NFD").replace(/[\u0300-\u036f]/g, '').replace(regex, '');
      if (value !== sanitized) {
        this.ngControl.control?.setValue(sanitized);
      }
      return;
    }

    if (this.name === 'date') {
      const regex = /[^0-9\-]/g;
      sanitized = value.replace(regex, '');
      if (value !== sanitized) {
        this.ngControl.control?.setValue(sanitized);
      }
      return;
    }

    if (this.name === 'time') {
      const regex = /[^0-9\:]/g;
      sanitized = value.replace(regex, '');
      if (value !== sanitized) {
        this.ngControl.control?.setValue(sanitized);
      }
      return;
    }
    
  
    if (this.name === 'phone') {
      sanitized = value.replace(/[^0-9+]/g, '');
      const plusIndex = sanitized.indexOf('+');
      if (plusIndex > 0) {
        sanitized = sanitized.replace(/\+/g, '');
      } else if (plusIndex === 0) {
        sanitized = '+' + sanitized.slice(1).replace(/\+/g, '');
      }
      if (value !== sanitized) {
        this.ngControl.control?.setValue(sanitized);
      }
      return;
    }
  
    if (this.name === 'first_name' || this.name === 'last_name') {
      const regex = /[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g;
      sanitized = value.normalize("NFD").replace(/[\u0300-\u036f]/g, '').replace(regex, '');
      if (value !== sanitized) {
        this.ngControl.control?.setValue(sanitized);
      }
      return;
    }

    const regex = this.allowAt
      ? /[^a-zA-Z0-9áéíóúÁÉÍÓÚñÑ@._%+\-]/g
      : /[^a-zA-Z0-9áéíóúÁÉÍÓÚñÑ\s]/g;
    sanitized = value.normalize("NFD").replace(/[\u0300-\u036f]/g, '').replace(regex, '');
    if (value !== sanitized) {
      this.ngControl.control?.setValue(sanitized);
    }
  }
  
}